/* bs-products — carousel mobile (flechas + counter) */
/* Desktop oculta el nav via CSS, JS se inicializa pero no daña: scroller queda visible sin scroll. */

(function () {
  'use strict';

  class BsProductsCarousel {
    constructor(section) {
      this.section = section;
      this.scroller = section.querySelector('[data-bs-products-scroller]');
      this.row = this.scroller ? this.scroller.querySelector('.bs-products__row') : null;
      this.counter = section.querySelector('[data-bs-products-counter]');
      this.prevBtn = section.querySelector('[data-direction="prev"]');
      this.nextBtn = section.querySelector('[data-direction="next"]');
      this.cards = this.scroller ? this.scroller.querySelectorAll('.bs-products__card') : [];
      this.totalCards = this.cards.length;

      if (!this.scroller || this.totalCards === 0) {
        return;
      }

      this.bindEvents();
      this.checkOverflow();
      this.updateUi();
    }

    bindEvents() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.scrollByCard(-1));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.scrollByCard(1));
      }
      this.scroller.addEventListener('scroll', () => this.updateUi(), { passive: true });

      // Re-evaluar al hacer resize (cambia visible cards count, sobre todo entre mobile y desktop)
      window.addEventListener(
        'resize',
        () => {
          this.checkOverflow();
          this.updateUi();
        },
        { passive: true }
      );
    }

    // Detecta si el contenido del scroller desborda el contenedor visible.
    // En desktop usamos esto para decidir entre layout pixel-perfect (≤7 cards,
    // space-between + nav oculto) o carousel mode (>7 cards, scroll + nav visible).
    // En mobile/tablet la CSS ya usa flex-start + gap, asi que el flag no cambia
    // nada visible — pero lo seteamos igual para consistencia.
    checkOverflow() {
      if (!this.scroller) return;
      const tolerance = 1; // subpixel rounding
      const isOverflowing = this.scroller.scrollWidth > this.scroller.clientWidth + tolerance;
      if (isOverflowing) {
        this.section.dataset.overflow = 'true';
      } else {
        this.section.removeAttribute('data-overflow');
      }
    }

    getStep() {
      // Step = card width + gap. Lee del DOM real para soportar viewport changes.
      const cardWidth = this.cards[0].offsetWidth;
      let gap = 13;
      if (this.row) {
        const computed = window.getComputedStyle(this.row);
        const parsedGap = parseFloat(computed.gap || computed.columnGap);
        if (!Number.isNaN(parsedGap)) {
          gap = parsedGap;
        }
      }
      return cardWidth + gap;
    }

    scrollByCard(direction) {
      const step = this.getStep();
      const prefersReduced =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const behavior = prefersReduced ? 'auto' : 'smooth';
      const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
      const currentScrollLeft = this.scroller.scrollLeft;
      // Cards evenly spaced (step = card-width + gap uniforme) → currentScrollLeft - step
      // siempre cae en el snap-start anterior. Mismo patron bs-testimonials/bs-product-carousel.
      let target = direction > 0 ? currentScrollLeft + step : currentScrollLeft - step;
      target = Math.max(0, Math.min(target, maxScroll));
      this.scroller.scrollTo({ left: target, behavior });
    }

    updateUi() {
      const scrollLeft = this.scroller.scrollLeft;
      const scrollRight = this.scroller.scrollWidth - this.scroller.clientWidth - scrollLeft;

      if (this.prevBtn) {
        this.prevBtn.disabled = scrollLeft < 1;
      }
      if (this.nextBtn) {
        // Tolerancia 1px por rounding de scrollWidth en algunos browsers
        this.nextBtn.disabled = scrollRight < 1;
      }

      if (this.counter) {
        // Counter adaptive: el TOTAL es el numero de "posiciones de scroll" segun
        // cuantas cards caben visibles en el viewport actual.
        // - Mobile (2 visibles, 7 cards): totalPositions = 7-2+1 = 6 -> "1/6" a "6/6"
        // - Tablet (3 visibles, 7 cards): totalPositions = 7-3+1 = 5 -> "1/5" a "5/5"
        // - Desktop (7 visibles): totalPositions = 1 -> "1/1" (nav oculto via CSS)
        const step = this.getStep();
        // +0.1 tolerancia para cuando N cards caben EXACTO en el clientWidth (desktop overflow:
        // 7×156 + 6×6 = 1128 inner; raw = 6.96 ≈ 7, sin tolerancia caeria a 6).
        const cardsVisible = step > 0 ? Math.max(1, Math.floor(this.scroller.clientWidth / step + 0.1)) : 1;
        const totalPositions = Math.max(1, this.totalCards - cardsVisible + 1);

        const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
        let idx;
        if (maxScroll <= 0) {
          idx = 1;
        } else {
          const progress = scrollLeft / maxScroll;
          idx = Math.round(progress * (totalPositions - 1)) + 1;
        }
        const clampedIdx = Math.max(1, Math.min(idx, totalPositions));
        this.counter.textContent = clampedIdx + ' / ' + totalPositions;
      }
    }
  }

  function init(root) {
    const sections = (root || document).querySelectorAll('.bs-products');
    sections.forEach((section) => {
      // Evitar doble init si ya tiene instancia (tras shopify:section:load)
      if (section.__bsProductsInit) return;
      section.__bsProductsInit = true;
      new BsProductsCarousel(section);
    });
  }

  // Init al cargar el DOM (script tiene defer => DOM ya parseado)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // Re-init cuando el customizer recarga la section
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.bs-products');
    if (section) {
      section.__bsProductsInit = false;
      init(event.target);
    }
  });
})();
